/**
 * The running app version, used by the force-update gate against
 * `app_config/global.minAppVersion` (semver compare).
 *
 * Kept as a const so both web and the Capacitor Android build agree on it.
 * Bump this in lockstep with the Android `versionName` in build.gradle.
 * Can be overridden at build time via VITE_APP_VERSION.
 */
export const APP_VERSION: string = import.meta.env.VITE_APP_VERSION ?? '0.1.0';

/**
 * Compare two dotted semver-ish strings ("1.2.3"). Missing segments are 0.
 * Returns <0 if a<b, 0 if equal, >0 if a>b. Non-numeric segments treated as 0.
 */
export function compareVersions(a: string, b: string): number {
  const pa = a.split('.').map((s) => parseInt(s, 10) || 0);
  const pb = b.split('.').map((s) => parseInt(s, 10) || 0);
  const len = Math.max(pa.length, pb.length);
  for (let i = 0; i < len; i++) {
    const da = pa[i] ?? 0;
    const db = pb[i] ?? 0;
    if (da !== db) return da - db;
  }
  return 0;
}

/** True when the running version is below the required minimum. */
export function isBelowMinVersion(current: string, min: string): boolean {
  return compareVersions(current, min) < 0;
}
